import { render } from "./insurancetemplate.vue?vue&type=template&id=0074b3f5&scoped=true"
import script from "./insurancetemplate.vue?vue&type=script&lang=js"
export * from "./insurancetemplate.vue?vue&type=script&lang=js"

import "./insurancetemplate.vue?vue&type=style&index=0&id=0074b3f5&scoped=true&lang=css"

import exportComponent from "/Users/alexisbailly/Documents/Programming/Website/vueform/Wealth & Retirement/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0074b3f5"]])

export default __exports__